import * as React from "react";
import {VeboxModels} from "../../../types/veboxModels";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import Package = VeboxModels.Package;

interface PackagesContextType {
    packages: VeboxModels.Package[];
    setPackages: (packages: VeboxModels.Package[]) => void;
    fetchPackages: (codes: string[]) => Promise<VeboxModels.Package[]>;
    movePackages: (codes: string[]) => Promise<void>;
}

export const PackagesContext = React.createContext<PackagesContextType>({} as any);

export const PackagesProvider: React.FC = ({children}) => {

    const [packagesData, setPackagesData] = React.useState<VeboxModels.Package[]>([]);

    const fetchPackages = (codes: string[]) => {
        return getPackages(codes)
            .then(packages => {
                const notFoundPackages = codes
                    .filter(code => packages.findIndex(p => p.code === code) === -1)
                    .map<Package>(code => ({
                        guid: null,
                        status: VeboxModels.PackageStatus.NOT_FOUND,
                        code,
                        deviceModel: null,
                        deviceQuantity: null,
                    }));
                return [...packages, ...notFoundPackages];
            })
            .then(packages => {
                setPackagesData(packages);
                return packages;
            });
    }

    const movePackages = (codes: string[]) => {
        return claimPackages(codes);
    }

    return (
        <PackagesContext.Provider
            value={{
                packages: packagesData,
                setPackages: setPackagesData,
                fetchPackages,
                movePackages
            }}
        >
            {children}
        </PackagesContext.Provider>
    );
}

export function getPackages(codes: string[]) {
    return new Promise<VeboxModels.Package[]>((res, rej) => {
        RestDataLoader.loadData(
            `packages?${encodeArrayHasURLParams("packagesCode", codes)}`,
            {},
            (data) => res(data.list),
            rej,
        );
    });
}

function claimPackages(codes: string[]) {
    return new Promise<void>((res, rej) => {
        RestDataLoader.putJSON(
            `packages/move`,
            {
                list: codes
            },
            res,
            rej,
        );
    });
}

function encodeArrayHasURLParams(arrayName: string, values: any[]) {
    return values
        .map((value, i) => `${arrayName}=${value}${i < values.length - 1 ? "&" : ""}`)
        .reduce((a, x) => a + x, "");
}